export function getRooms(rooms) {
  return rooms.map(room => {
    var _a;
    return {
      children: (_a = room.children) === null || _a === void 0 ? void 0 : _a.map(child => child.age),
      adults: room.adults
    };
  });
}